import React from 'react';
import axios from 'axios';
import {Boton, Accion} from '../../comun/Index';
import Nuevo from './Nuevo';

class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      expandir:null
    }
  }

  expandir(id){
    const {expandir} = this.state;
    if (expandir !== id){
      this.setState({expandir:id});
    } else {
      this.setState({expandir:null});
    }
  }

  render(){
    const {expandir} = this.state;
    const {juzgados} = this.props;
    return(
      <div className="Lista">
        {juzgados.map((item, index) => {
          return(
            <div
              key={index}
              className="Item"
              style={{backgroundColor:index%2===1?'#e3e3e3':'#f0f0f0'}}
            >
              <div className="Detalles">
                <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                  <Accion
                    icono={expandir === index ? 'keyboard_arrow_up': 'keyboard_arrow_down'}
                    ayuda="Expandir"
                    backgroundColor="lightgrey"
                    disabled={false}
                    onClick={() => this.expandir(index)}
                  />
                  {`(${item.id}) - N°${item.numero} - ${item.nombre} - ${item.materia} - Distrito: ${item.distrito} - Localidad: ${item.localidad} `}
                </div>
                <div className="Acciones">
                  <Accion
                    icono="edit"
                    ayuda="Editar"
                    backgroundColor="#00a5e5"
                    disabled={false}
                    onClick={() => this.props.editar(index)}
                  />
                </div>
              </div>
              {expandir === index &&
                <div className="Preguntas">
                  <p style={{margin:3}}>
                    Área: <strong>{item.area}</strong>
                  </p>
                </div>
              }
            </div>
          )
        })}
      </div>
    );
  }
}

const getLocalidades = function(){
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + '/localidades/listar/')
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve(res.data.localidades)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

const getMaterias = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/emisores/todos/materias/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.materias)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}


const getJuzgados = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/emisores/todos/juzgados/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.juzgados)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

export default class Usuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      materias:[],
      localidades:[],
      juzgados:[],
      showModal:false,
      datosModal:{}
    }
  }

  componentDidMount(){
    getLocalidades()
    .then((localidades) => {
      getMaterias()
      .then((materias) => {
        this.setState({localidades, materias});
        this.actualizar();
      })
    })
    .catch((error) => {
      alert("Ocurrió un error");
      console.log(error)
    })
  }



  async actualizar(){
    getJuzgados()
    .then((juzgados) => this.setState({juzgados}))
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    }) 
  }

  nuevo(){
    this.setState({datosModal:{},showModal:true});
  }

  // editar(index){
  //   this.setState({datosModal:this.state.usuarios[index]});
  //   this.setState({showModal:true});
  // }

  guardar(datos){
    const url = localStorage.getItem('apiUrl') + '/emisores/admin/juzgado';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.setState({showModal:false,datosModal:{}});
        this.actualizar();
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }


  render(){
    const {showModal, datosModal, juzgados, localidades, materias} = this.state;
    return(
      <div className="TramitesTodo">
        {showModal &&
          <Nuevo
            datos={datosModal}
            localidades={localidades}
            materias={materias}
            salir={() => {window.scrollTo(0,0);this.setState({showModal:false,datosModal:{}})}}
            guardar={(datos) => {window.scrollTo(0,0);this.guardar(datos)}}
          />
        }
        <h3>Juzgados</h3>
        <Listado
          juzgados={juzgados}
          editar={(index) => {window.scrollTo(0,0);this.editar(index)}}
          reestablecer={(id) => this.reestablecer(id)}
          cambiarEstado={(id,estado) => this.cambiarEstado(id, estado)}
        />
        <Boton
          backgroundColor="#00a5e5"
          titulo="Nuevo"
          onClick={() => {window.scrollTo(0,0);this.nuevo()}}
        />
      </div>
    );
  }
}
